import { render, staticRenderFns } from "./AssignedUsersCell.vue?vue&type=template&id=31b40386&scoped=true"
import script from "./AssignedUsersCell.vue?vue&type=script&lang=js"
export * from "./AssignedUsersCell.vue?vue&type=script&lang=js"
import style0 from "./AssignedUsersCell.vue?vue&type=style&index=0&id=31b40386&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b40386",
  null
  
)

export default component.exports